import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription , of } from 'rxjs';
import { GridApi } from 'ag-grid';
import { Constants } from '@utils/constants';
import { OrdersHistoryPresenter } from '@business/orders-history/orders-history.presenter';
import { DailyOrderService } from '@services/webFeeder/sckt-daily-order.service';
import { ConfigService } from '@services/webFeeder/config.service';

@Component({
  selector: 'app-order-chart',
  templateUrl: './order-chart.component.html'
})
export class OrderChartComponent implements OnInit, OnDestroy {

  @Input() set symbol(value: string) {
    this.dailyOrderSubscriptionList.forEach(sub => sub.unsubscribe());
    this.filters.quote = value || '-';
    if (this.gridApiOrders) {
      this.gridApiOrders.onFilterChanged();
    }
    this.subscribeOrders();
  }

  private accountSubscritionList: Array<Subscription> = [];
  private dailyOrderSubscriptionList: Array<Subscription> = [];
  private gridApiOrders: GridApi;
  private historyOrderPresenter: OrdersHistoryPresenter = new OrdersHistoryPresenter();

  msgOfflineNegotiation = Constants.MSG_OFFLINE_NEGOTIATION_01;
  account: string;
  loading: boolean;
  isFirstLoading = true;
  filters = { quote: '-', buyOrSell: 'Todos', state: 'Aberta' };

  constructor(
    private _configService: ConfigService,
    private _dailyOrderService: DailyOrderService
  ) { }

  ngOnInit() {
    this.loading = true;
    this.accountSubscritionList.push(
      this._configService.authHbLogged$.subscribe(loggedNegotiation => {
        if (loggedNegotiation) {
          this.account = this._configService.getBrokerAccountSelected();
        } else {
          if (this.account) {
            this.account = null;
            this._dailyOrderService.unsubscribeDailyOrder(this.account, Constants.WINDOW_NAME_ORDER_CHART);
            this.dailyOrderSubscriptionList.forEach(subscription => subscription.unsubscribe());
          }
        }
      })
    );

    this.accountSubscritionList.push(this._configService.changeAccountBillet$
      .subscribe(account => {
        if (account && account.toString() !== this.account) {
          this._dailyOrderService.unsubscribeDailyOrder(this.account, Constants.WINDOW_NAME_ORDER_CHART);
          this.dailyOrderSubscriptionList.forEach(subscription => subscription.unsubscribe());
          this.account = account;
          this.gridApiOrders.setRowData([]);
          this.subscribeOrders();
        }
      })
    );
  }

  ngOnDestroy() {
    this._dailyOrderService.unsubscribeDailyOrder(this.account, Constants.WINDOW_NAME_ORDER_CHART);
    this.dailyOrderSubscriptionList.forEach(subscription => subscription.unsubscribe());
    this.accountSubscritionList.forEach(subscription => subscription.unsubscribe());
  }

  onGridReady(params) {
    this.loading = false;
    this.gridApiOrders = params.api;
    this.subscribeOrders();
  }

  subscribeOrders() {
    if (this.account) {
      this.dailyOrderSubscriptionList.push(this._dailyOrderService.subscribeDailyOrder(this.account, Constants.WINDOW_NAME_ORDER_CHART)
        .subscribe(data => {
          if (data && data.length > 0) {
            this.updateOrders(data);
          }
        }
        ));
    }
    this.dailyOrderSubscriptionList.push(
      this._dailyOrderService.messagesDailyOrder
        .subscribe(res => {
          this.updateOrders(res);
        })
    );
  }

  updateOrders(response) {
    if (!this.gridApiOrders) {
      return;
    }
    const dataLength = this.gridApiOrders.getDisplayedRowCount();
    const presenterOrdersAll = [...this.historyOrderPresenter.transformDailyOrder(response)];
    const presenterOrders = presenterOrdersAll.filter(x => x.quote === this.filters.quote);
    if (dataLength === 0) {
      this.gridApiOrders.setRowData(presenterOrders);
    } else {
      presenterOrders.forEach(order => {
        const renderedNodes = this.gridApiOrders.getRenderedNodes();
        const orderToEdit = renderedNodes.findIndex(item => item.id === order['orderID']);
        if (orderToEdit !== undefined && orderToEdit !== -1) {
          this.gridApiOrders.updateRowData({ update: [order] });
          this.gridApiOrders.refreshCells({ columns: ['actions'], force: true });
        } else {
          this.gridApiOrders.updateRowData({ add: [order], addIndex: (this.gridApiOrders.getDisplayedRowCount()) });
        }
      });
    }
  }

}
